var link_viewer_default = {
  "fontElementMap": "_7H7-d",
  "link": "y1wq6",
  "linkInEditor": "o7K7l",
  "linkInViewer": "_93i8C",
  "toolbarUrlContainer": "jtWtI",
  "toolbarUrl": "XkA2y",
  "toolbarUrlAnchor": "LSO4-"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
